export const NO_CONNECTIVITY_PROMPT = {
  id: "MSG99603",
  description:
    "We have encountered an issue updating the transaction store with the outcome of this transaction and it has therefore been unable to complete successfully. Please try again later.",
};
